<template>
    <Conversion1Widget
            :main_icon="main_icon"
            :load_url="load_url"
            :title="title">
    </Conversion1Widget>
    <!--<b-card class="merge-card mb-4 conversion1-card" body-class="d-flex justify-content-between flex-column">-->
        <!--<template v-slot:header>-->
            <!--<span class="mb-0 h6 float-left text-dark">-->
            <!--<i class="mr-1" :class="main_icon"></i>Conversion 1</span>-->
        <!--</template>-->

        <!--<Conversion1Widget-->
                <!--:main_icon="main_icon"-->
                <!--:load_url="load_url"-->
                <!--:title="title">-->
        <!--</Conversion1Widget>-->

    <!--</b-card>-->

</template>

<script>
    import Conversion1Widget from '../../widgets/Conversion1.vue';
    export default {
        name: 'Conversion1Trends',
        components: {Conversion1Widget},
        data() {
            return {
                main_icon: 'fa-duotone fa-chart-pie',
                title: 'Conversion 1',
                load_url: '/dashboards/conversion1',
            };
        },
    };
</script>

<style scoped>
    .conversion1-card {
        height: calc(100% - 1.5rem);
    }
</style>